import headerEn from "assets/images/v131/header-en.webp"
import ratingEn from "assets/images/v131/rating-en.webp"
import previewEn from "assets/images/v131/preview-en.webp"
import reviewsEn from "assets/images/v131/reviews-en.webp"

import headerDe from "assets/images/v131/header-de.webp"
import ratingDe from "assets/images/v131/rating-de.webp"
import previewDe from "assets/images/v131/preview-de.webp"
import reviewsDe from "assets/images/v131/reviews-de.webp"

import headerIt from "assets/images/v131/header-it.webp"
import ratingIt from "assets/images/v131/rating-it.webp"
import previewIt from "assets/images/v131/preview-it.webp"
import reviewsIt from "assets/images/v131/reviews-it.webp"

import headerEs from "assets/images/v131/header-es.webp"
import ratingEs from "assets/images/v131/rating-es.webp"
import previewEs from "assets/images/v131/preview-es.webp"
import reviewsEs from "assets/images/v131/reviews-es.webp"

import headerFr from "assets/images/v131/header-fr.webp"
import ratingFr from "assets/images/v131/rating-fr.webp"
import previewFr from "assets/images/v131/preview-fr.webp"
import reviewsFr from "assets/images/v131/reviews-fr.webp"

export const v131Images = {
  title: {
    en: headerEn,
    de: headerDe,
    it: headerIt,
    es: headerEs,
    fr: headerFr,
  },
  rating: {
    en: ratingEn,
    de: ratingDe,
    it: ratingIt,
    es: ratingEs,
    fr: ratingFr,
  },
  preview: {
    en: previewEn,
    de: previewDe,
    it: previewIt,
    es: previewEs,
    fr: previewFr,
  },
  reviews: {
    en: reviewsEn,
    de: reviewsDe,
    it: reviewsIt,
    es: reviewsEs,
    fr: reviewsFr,
  },
}
